import { Injectable } from '@angular/core'
import toastr from '../../../node_modules/toastr/toastr.js'

@Injectable({
  providedIn: 'root'
})
export class AlerterService {

  constructor() {
    toastr.options.progressBar = false
    toastr.options.newestOnTop = true
    toastr.options.positionClass = "toast-bottom-right"
    toastr.options.timeOut = 30000
    toastr.options.extendedTimeOut = 10000

  }

// {
//   "closeButton": true,
//   "debug": false,
//   "newestOnTop": true,
//   "progressBar": true,
//   "positionClass": "toast-bottom-right",
//   "preventDuplicates": false,
//   "showDuration": "300",
//   "hideDuration": "1000",
//   "timeOut": "5000",
//   "extendedTimeOut": "1000",
//   "showEasing": "swing",
//   "hideEasing": "linear",
//   "showMethod": "fadeIn",
//   "hideMethod": "fadeOut"
// }

  error(message: string, option?): void {
    toastr.error(message, option)
  }

  warning(message: string, option?): void {
    toastr.warning(message, option)
  }

  success(message: string, option?): void {
    toastr.success(message, option)
  }

  info(message: string, option?): void {
    toastr.info(message, option)
  }
}
